import { Spin } from "antd";

export const CenteredSpinner = ({ title }) => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      width: '100vw',
      backgroundColor: 'rgb(255 255 255 / 98%)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <Spin size="large" />
      {title ? <div style={{ marginTop: 16, color: '#0075FF', fontSize: 14 }}>
        {title || ''}
      </div> : ""}
    </div>
  </div>
);
